import { Table, TableModule } from 'primeng/table';
import { default as GridColumnsJSON } from './comp-matched-report-columns.json';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { saveAs } from 'file-saver';
import { Component, SimpleChanges, ViewChild } from '@angular/core';
import { EventTreeService } from 'app/Shared/Component/event-tree/event-tree.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { DataService } from 'app/Shared/Services/data.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { DialogModule } from 'primeng/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { UserService } from 'app/Shared/Services/user.service';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { Subscription } from 'rxjs';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConfirmationService, MenuItem, MessageService, TreeNode } from 'primeng/api';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { EventTreeDialogComponent } from 'app/Shared/Component/event-tree/event-tree-dialog.componenet';
import { asBlob, generateCsv } from 'export-to-csv';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { QuickSearchComponent } from 'app/Shared/Component/quick-search/quick-search.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { CompReviewViewDetailsComponent } from '../comp-review-view-details/comp-review-view-details.component';
import { TreeTableModule } from 'primeng/treetable';
import { CompReviewServiceService } from '../comp-review-service.service';
import { CheckboxModule } from 'primeng/checkbox';
import { DrawerModule } from 'primeng/drawer';
import { CommentViewerService } from 'app/Shared/Component/comment-viewer/comment-viewer.service';
import { CommentViewerComponent } from 'app/Shared/Component/comment-viewer/comment-viewer.component';
import { ContextMenuModule } from 'primeng/contextmenu';
import { CompReviewScheduleReportComponent } from '../comp-review-schedule-report/comp-review-schedule-report.component';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';

@Component({
  selector: 'app-comp-matched-report-details',
  standalone: true,
  imports: [FilterPanelComponent, MatProgressSpinner, MatTooltipModule, QuickSearchComponent,
    TableModule, LowerCasePipe, NgClass, DialogModule, TooltipModule,
    ToastModule, ConfirmDialogModule, EventTreeDialogComponent,
    ButtonModule, DrawerModule, FormsModule, ExportToCSVSComponent,CompReviewScheduleReportComponent,
    MatChipsModule, MatIconModule, SymbolPanelComponent, ContextMenuModule,BadgeModule,OverlayBadgeModule,
    CompReviewViewDetailsComponent, TreeTableModule, CommonModule, CheckboxModule, CommentViewerComponent],
  templateUrl: './comp-matched-report-details.component.html',
  styleUrl: './comp-matched-report-details.component.scss',
  providers: [CommentViewerService]
})
export class CompMatchedReportDetailsComponent {
  @ViewChild(('tt')) dt!: Table;
  GridColumns: any;
  columnJson: any = [];
  cols: any = []
  selectedRow: any = [];
  selectedNodes!: TreeNode[];
  selectedNode!: TreeNode;
  metaKeySelection: boolean = true;

  isGenerateSampleDialog: boolean = false;
  isDisplayCommentDialog: boolean = false;
  isDisplayViewDialog: boolean = false;
  isLoadingRecords: boolean = false;
  isDisplayEventTreeDialog: boolean = false;
  isDisplayAddCommentForm:boolean = true;
  GroupNameList: any = [];
  customSampleNameList: any = [];
  firmROEIDList: any = [];
  totalRecords!: any;
  Limit: any = { 'Start': '0', 'End': '20' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowcount: number = 0;
  startLimit: any = 0;
  endLimit!: number;
  subscription!: Subscription;
  firstRecordIndex: number = 0;
  userList: any = [];
  rowIndexForViewDialog: any;
  quickFilterArray: any = [];
  filterFieldDefaultValues: any = new Object();
  MatchedReportTreeViewData: any[] = [];
  buttonCaption: string = "Collapse";
  expandCollapseAll = "Expand All";
  contexMenuItems: MenuItem[];
  queryCommentGridColumns: any;
  commentStaticFilters: any;
  commentAPIDetail: any;
  sampleDrpListData: any;

  constructor(
    private readonly gridService: GridService,
    public constantService: ConstantService,
    public dataService: DataService,
    public eventTreeService: EventTreeService,
    public userService: UserService,
    private readonly emitterService: EmitterService,
    private readonly messageService: MessageService,
    public confirmationService: ConfirmationService,
    private readonly urlsService: UrlsService,
    private readonly sharedHttpClientService: SharedHttpClientService,
    public readonly compReviewServiceService: CompReviewServiceService,
    public readonly commentViewerService: CommentViewerService
  ) {
    this.totalRecords = 1;
    this.GridColumns = GridColumnsJSON['GridColumns'];
    this.quickFilterArray = GridColumnsJSON['Quick-Search-Filter'];
    this.queryCommentGridColumns = GridColumnsJSON['query-comment-columns'];
    this.compReviewServiceService.CATFieldTypesArrayList = this.userService.getDropDownList('type');
    this.filterFieldDefaultValues = { Type: this.compReviewServiceService.deaultEventTypeValues };
    this.contexMenuItems = [
      { label: 'Add Comment', icon: 'pi pi-plus', command: (event: any) => this.onBrowsecomCommentViewer() },
      { label: 'Toggle', icon: 'pi pi-sort', command: (event: any) => this.toggleSectedRowNode(this.selectedNode) }
    ];
    this.getApplicationFilters();
    this.getBrowseCommentViewerCount();
  }

  ngOnInit(): void {
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.getColumns();
    this.gridService.getUserList()
      .subscribe({
        next: (data: any) => {
          this.userList = data.Data;
          this.userList.unshift({ label: 'Select User', value: '' });
        }
      });
     this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value: any) => {
        if (value) {
          this.getApplicationFilters();
          this.getBrowseCommentViewerCount();
          this.compReviewServiceService.defaultFilter();
          this.compReviewServiceService.sampleFilter();
          this.getMatchedReportData();
          this.getGroupNameList();
        }
      }
    });
    this.compReviewServiceService.defaultFilter();
    this.compReviewServiceService.sampleFilter();
    this.getMatchedReportData();
    this.getGroupNameList();
  }


  ngAfterViewInit() {
    if (this.dt != null) {
      this.dt.resetScrollTop = function () { }
    }
  }
  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
    }
  }
  getGroupNameList() {
    let payload: any = {};
    payload["data"] = this.compReviewServiceService.DefaultFilterArray;
    payload["mpid"] = this.userService.getActiveMPID();
    payload["reportDate"] = this.userService.getyyyyMMddDateFormate(this.compReviewServiceService.LastExecutionCompDate[0]);

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Comparative_Review_Report_GroupNames), payload)
      .subscribe({
        next: (Element: any) => {
          let dataset: any = Element;
          if (dataset) {
            this.GroupNameList = dataset["groupNameList"];
          }

        }, error: (err: HttpErrorResponse) => {
        }
      });
  }

  onHeaderCheckboxToggle(event: any) {
    if (event.checked) {
      this.selectedNodes = this.getAllNodes(this.MatchedReportTreeViewData);
    } else {
      this.selectedNodes = [];
    }
  }

  toggleSectedRowNode(node: any) {
    node.expanded = !node.expanded;
    this.MatchedReportTreeViewData = [...this.MatchedReportTreeViewData];
  }

  onCommentContext(node: any) {

  }

  getAllNodes(nodes: any[]): any[] {
    let allNodes: any[] = [];
    for (let node of nodes) {
      allNodes.push(node);
      if (node.children) {
        allNodes = allNodes.concat(this.getAllNodes(node.children));
      }
    }
    return allNodes;
  }

  isAllChecked(): boolean {
    if (!this.MatchedReportTreeViewData || this.MatchedReportTreeViewData.length === 0) {
      return false;
    }
    const allNodeKeys = this.getAllNodes(this.MatchedReportTreeViewData).map(node => node.key);
    const selectedNodeKeys = this.selectedNodes.map(node => node.key);
    return allNodeKeys.length > 0 && allNodeKeys.every(key => selectedNodeKeys.includes(key));
  }

  exapandORcollapse(nodes: any) {
    if (this.buttonCaption === "Expand") {
      this.buttonCaption = "Collapse";
      this.expandCollapseAll = "Expand All";
      this.collapseAll(nodes);
    } else if (this.buttonCaption === "Collapse") {
      this.buttonCaption = "Expand";
      this.expandCollapseAll = "Collapse All";
      this.exapandAll(nodes);
    }
    //refresh the data
    this.MatchedReportTreeViewData = [...this.MatchedReportTreeViewData];
  }

  nodeSelect(event: any) {
    const node = event.node;
    this.selectedNodes = [];
    this.selectedNodes.push(node);
    if (!node.expanded || node.expanded == undefined) {
      node.expanded = true;
      this.MatchedReportTreeViewData = [...this.MatchedReportTreeViewData];
    }
  }

  nodeUnselect(event: any) {
    const node = event.node;
    if (node.expanded || node.expanded == undefined) {
      node.expanded = false;
      this.MatchedReportTreeViewData = [...this.MatchedReportTreeViewData];
    }
  }

  onNodeExpand(event: any) {
    const node = event.node;
    if (node.children) {
      if (!node.expanded || node.expanded == undefined) {
        node.expanded = true;
        this.exapandAll(node.children);
      }
    }
  }

  onNodeCollapse(event: any) {
    const node = event.node;
    if (node.children) {
      if (node.expanded || node.expanded == undefined) {
        node.expanded = false;
        this.collapseAll(node.children);
      }
    }
  }

  collapseAll(nodes: any) {
    for (let node of nodes) {
      if (node.children) {
        if (node.expanded || node.expanded == undefined) {
          node.expanded = false;
          this.collapseAll(node.children);
        }
      }
    }
    //refresh the data
    this.MatchedReportTreeViewData = [...this.MatchedReportTreeViewData];
  }

  exapandAll(nodes: any) {
    for (let node of nodes) {
      if (node.children) {
        if (!node.expanded || node.expanded == undefined) {
          node.expanded = true;
          this.exapandAll(node.children);
        }
      }
    }
    //refresh the data
    this.MatchedReportTreeViewData = [...this.MatchedReportTreeViewData];
  }

  clearQuickSearch($event: any) {
    this.FilterEventClearGroupName();
    this.compReviewServiceService.DefaultFilterArray = $event;
    this.getMatchedReportData();
  }

  FilterEventClearSymbol(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.emitterService.ResetQuickFilterPanelEvent.emit("Symbol");
  }

  setActiveQuickFilterGroupName(event: any) {
    let index = this.compReviewServiceService.DefaultFilterArray.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'groupName');
    if (index) {
      this.compReviewServiceService.DefaultFilterArray[index].values = event;
      this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
      this.FilterApplyFilterEvent(this.compReviewServiceService.DefaultFilterArray);
    }
  }

  FilterEventCompReportReload(event: any) {
    this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
  }

  FilterEventClearGroupName(event?: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("GroupName");
  }

  FilterApplyFilterEvent(event?: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.compReviewServiceService.LastExecutionCompDate = event[0]["values"];
    this.compReviewServiceService.DefaultFilterArray = event;
    this.getMatchedReportData();
    this.getGroupNameList();
    this.getBrowseCommentViewerCount();
    this.getApplicationFilters();
    this.expandCollapseAll = "Expand All";
  }

  onRowOrderID(index: any, rowData: any) {
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow.push(rowData);
    }
  }



  getMatchedReportData() {
    this.isLoadingRecords = true;
    this.compReviewServiceService.getMatchedReportData()
      .subscribe({
        next: (Element: any) => {
          this.isLoadingRecords = false;
          let dataset: any = Element;
          if (dataset.Data) {
            this.MatchedReportTreeViewData = dataset.Data;
            this.compReviewServiceService.disableRunCompReportButton = this.MatchedReportTreeViewData.length == 0;
            this.totalRecords = this.gridService.handleNoRecordsPageNumber(dataset.totalCount);
          }
        }, error: (err: HttpErrorResponse) => {
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.isLoadingRecords = false;
        }
      });
  }

  onView(rowData: any, rowNode: any, index: any) {
    this.selectedRow = [];
    this.selectedRow.push(rowData);
    this.nodeSelect(rowNode);
    this.rowIndexForViewDialog = index;
    this.isDisplayViewDialog = true;
  }

  closeAllDialogs(value: any) {
    this.dataService.roeSelectedRecords = [];
    this.isDisplayViewDialog = false;
    this.isDisplayCommentDialog = false;
    this.eventTreeService.isDialogOpen = false;
    this.isDisplayEventTreeDialog = false;
  }

  getSampleNameList(rowData: any) {
    let rowIDList: any = [];
    for (let element of rowData) {
      rowIDList.push(element['sampleName']);
    }
    return rowIDList;
  }

  onDelete(rowData: any, rowNode: any, index: any) {
    this.nodeSelect(rowNode);
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow.push(rowData);
    }
    let payload: any = {};
    payload["mpid"] = this.userService.getActiveMPID();
    payload["reportDate"] = this.userService.getyyyyMMddDateFormate(this.compReviewServiceService.LastExecutionCompDate[0]);
    payload["user"] = this.userService.getUserFirstName();
    payload["recordsList"] = this.getSampleNameList(this.selectedRow);
    payload["recordType"] = this.getRecordType(rowData);
    this.confirmationService.confirm({
      message: 'Are you sure, you want to remove the sample "' + rowData["sampleName"] + '" records?',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass: "confirm-dialog-button",
      rejectButtonStyleClass: "confirm-dialog-button",

      accept: () => {
        this.userService.logUserActivity("Remove Sample: " + rowData["sampleName"], null, {
        'Text1': this.userService.userFirstName +"Remove Sample: " + rowData["sampleName"],
        'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
        });
        this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.Comparative_Review_Report_Delete), payload)
          .subscribe({
            next: (Element: any) => {
              let dataset: any = Element;
              let status = dataset["status"];
              let msg = dataset["msg"];
              if (status == "success") {
                this.messageService.add({ severity: 'success', summary: 'Delete', detail: msg });
                index = this.MatchedReportTreeViewData.findIndex(record => record["data"].sampleName === rowData["sampleName"]);
                if (index >= 0) {
                  this.MatchedReportTreeViewData.splice(index, 1);
                }
                this.MatchedReportTreeViewData = [...this.MatchedReportTreeViewData];
                this.getGroupNameList();
              } else {
                this.messageService.add({ severity: 'warn', summary: 'Delete', detail: msg });
              }
            }, error: (err: HttpErrorResponse) => {
              this.messageService.add({ severity: 'error', summary: 'Delete', detail: 'Error Occurred' });
            }
          });
      }
    });
  }

  onJsonViewer(rowData: any, rowNode: any) {
    this.selectedRow = [];
    this.selectedRow[0] = rowData;
    this.nodeSelect(rowNode);
  }



  onEventTree(rowData: any, rowNode: any) {
    this.eventTreeService.isDialogOpen = true;
    this.isDisplayEventTreeDialog = true;
    this.selectedRow = [];
    this.selectedRow[0] = rowData;
    this.nodeSelect(rowNode);
  }

  onShowOrderViewer(rowData: any, rowNode: any, rowIndex: any) {
    this.selectedRow = [];
    this.selectedRow[0] = rowData;
    this.nodeSelect(rowNode);
    this.emitterService.isOrderViewerOpenCloseEvent.emit(
      {
        display: true,
        rowData: rowData,
        pageName: 'Finra-Exception'
      });
  }

  getTooltipContent(row: any, rowNode: any) {

    return `<strong style="color: #83d0f2;">Status:&nbsp;</strong><span style="color: #e8f0fe;">${row.commentStatus}</span>
             <strong style="color: #83d0f2;">Owner:&nbsp;</strong><span style="color: #e8f0fe;">${row.commentOwner}</span>
             <strong style="color: #83d0f2;">Comment:&nbsp;</strong><span style="color: #e8f0fe;">${row.commentDetails}</span>`;
  }

  onComment(rowData: any, rowNode: any) {
    this.isDisplayAddCommentForm = true;
    this.nodeSelect(rowNode);
    if (this.selectedRow.length <= 1) {
      this.selectedRow = [];
      this.selectedRow.push(rowData);
    }
    this.commentStaticFilters = [
      { filterName: 'Report Date', filterValue: this.userService.getyyyyMMddDate(rowData["reportDate"]), fieldName: 'reportDate' },
      { filterName: 'Sample Name', filterValue: rowData["sampleName"], fieldName: 'sampleName' },
      { filterName: 'OrderID', filterValue: rowData["orderID"], fieldName: 'orderID' }];
    this.isDisplayCommentDialog = true;
    this.userService.logUserActivity("Add Comment", null, {
        'Text1': this.userService.userFirstName + ' Add Comment',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.commentStaticFilters)
    });
    this.addComment();
  }

  getRecordType(rowdata: any) {
    if (rowdata) {
      return rowdata["recordType"] ?? "sample";
    }

  }

  addComment() {
    this.commentAPIDetail = {
      "GetCommentURL": APIURL.Comp_Review_Get_Comments,
      "AddCommentURL": APIURL.Comp_Review_Add_Comment,
      "Module": "Comparative-Report-Matched-Report"
    };
  }

  exportToCSV(event: any) {
    this.messageService.add({ severity: 'success', summary: 'CSV Export', detail: 'File Export Started' });
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    }
    this.gridService.getData(
      APIURL.Comparative_Review_Report_Export,
      this.compReviewServiceService.DefaultFilterArray,
      this.Limit,
      '',
      this.compReviewServiceService.pageName
    ).subscribe({
      next: (response: any) => {
        let dataset: any = response;
        let reportDate = this.userService.getyyyyMMddDateFormate(this.compReviewServiceService.LastExecutionCompDate[0]);
        let data = dataset.Data;
        let title = 'RSMS_Comp_Matched_Report_' + reportDate;
        if (data.length > 0) {
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: title,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            filename: this.userService.getActiveMPID() + '_' + title,
          };
          const csvData = this.constantService.getExportData(data, event.gridColumn);
          const csv = generateCsv(options)(csvData);
          const blob = asBlob(options)(csv);
          saveAs(blob, options.filename);

          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.compReviewServiceService.DefaultFilterArray.filter((filterParam: any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
          this.messageService.add({ severity: 'success', summary: 'CSV Export', detail: 'File Exported Successfully' });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.compReviewServiceService.DefaultFilterArray.filter((filterParam: any) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
        this.emitterService.exportToCSVData.emit(true);
      }, error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.compReviewServiceService.DefaultFilterArray.filter((filterParam: any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });
  }

  updateDefaultArray($event: any) {
    this.compReviewServiceService.optedApplicationFilter = new Object(); // Unselected Application Filter
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol/Exception-Code Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.compReviewServiceService.DefaultFilterArray = $event;
    this.compReviewServiceService.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;

    this.getMatchedReportData();
  }

  getApplicationFilters(filterQueryName?: any) {
    this.compReviewServiceService.getApplicationFilters(filterQueryName)
      .subscribe({
        next: (Element: any) => {
          let dataResultSet: any = Element;
          this.customSampleNameList=[];
          this.sampleDrpListData=[];    
          this.compReviewServiceService.applicationFilters = dataResultSet.Data;
           for(let element of this.compReviewServiceService.applicationFilters){
                this.customSampleNameList.push(element['filter_query_name']);
                this.sampleDrpListData.push( { label: element['filter_query_name'], value: element['filter_query_name'] });
            }
        },
        error: (err: HttpErrorResponse) => {
        }
      });
  }

  RemoveCustomSampleFilterQuery(optedFilterQuery: any) {
    this.confirmationService.confirm({
      message: 'This saved custom sample query might be used by other users. Are you sure you want to delete this custom sample "'+optedFilterQuery.filter_query_name+'" query ?',
      header: 'Confirmation',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      defaultFocus: 'reject',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass: "confirm-dialog-button",
      rejectButtonStyleClass: "confirm-dialog-button",
      accept: () => {
        this.messageService.add({ severity: 'info', summary: 'Removing custom sample filter', detail: 'Please wait while deleting custom sample filter...' });
        this.compReviewServiceService.RemoveCustomSampleFilterQuery(optedFilterQuery)
          .subscribe({
            next: (Element: any) => {
              let dataResultSet: any = Element;
              if (dataResultSet.status) {
                this.messageService.add({ severity: 'success', summary: 'Delete Message', detail: dataResultSet.message });
                this.userService.logUserActivity('Delete custom sample query', null, {
                  'Text1': dataResultSet.message + ' | ' + 'User ' + this.userService.getUserName() + ' deleted custom sample filter query by Name: ' + optedFilterQuery.filter_query_name,
                  'Text2': 'Query Parameters: ' + optedFilterQuery.filter_queries
                });
              }
              this.getApplicationFilters();
              (Object.keys(this.compReviewServiceService.optedApplicationFilter).length > 0
                && this.compReviewServiceService.optedApplicationFilter.id === optedFilterQuery.id
                && this.compReviewServiceService.optedApplicationFilter.filter_query_name.trim() === optedFilterQuery.filter_query_name.trim());
            },
            error: (err: HttpErrorResponse) => {
            }
          });
      }
    });
  }

  onBrowsecomCommentViewer() {
    this.isDisplayAddCommentForm = false;
    let reportDate = new Date(this.compReviewServiceService.LastExecutionCompDate[0]);
    this.commentStaticFilters = [
      { filterName: 'FromDate', filterValue: this.userService.getFirstDateOfMonth(reportDate), fieldName: 'reportDate' },
      { filterName: 'ToDate', filterValue: this.userService.getLastDateOfMonth(reportDate), fieldName: 'reportDate' }];
    this.isDisplayCommentDialog = true;
    this.selectedRow = [];
    this.userService.logUserActivity("Browse Comment Viewer", null, {
          'Text1': this.userService.userFirstName + ' Browse Comment Viewer',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.commentStaticFilters)
    });
    this.addComment();
  }

  getBrowseCommentViewerCount()
  {
    this.commentViewerService.getBrowseCommentViewerCount(this.compReviewServiceService.LastExecutionCompDate[0], "Comparative-Report-Matched-Report");
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

}
